import api from './AxiosInstance';

export class PaysService{
  getAllPays = async () => {
    try {
      const response = await api.get(`/Participant/Pays/List`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };

 
}


